<template>
  <ion-page>
    <ion-content :scroll-events="true">
      <Header-Section />
      <div class="main-content">
        <div class="right-content">
          <div class="content-inner">
            <div class="text-box">
              <div class="inner flex">
                <span
                  ><i><svg-icon name="edit-alt" /></i
                ></span>
                <h3>Create a Text Story</h3>
              </div>
            </div>
            <input
              ref="files"
              type="file"
              id="read-file1"
              multiple
              hidden
              @change="onFileChange($event.target.files)"
            />
            <div id="uploadBtn1" class="upload-box">
              <div class="inner flex">
                <span
                  ><i><svg-icon name="scenery" /></i
                ></span>

                <h3>Create a Photo/Video Story</h3>
              </div>
            </div>
          </div>
        </div>
        <div class="create-text-story-modal">
          <div class="story-content">
            <div class="story-title">
              <h2>Write your Read below</h2>
              <span class="cancelBtn"
                ><i><svg-icon name="multiply" /></i
              ></span>
            </div>
            <div class="story-body">
              <textarea
                name=""
                :class="`text-area color-box ${color}`"
                ref="roomTextarea1"
                cols="30"
                id="demo"
                rows="10"
                placeholder="Start typing..."
                @input="onChangeInput"
              ></textarea>
            </div>
            <p>Select solid color background.</p>
            <div class="color-pallet">
              <div
                class="color-box1 gradient-1"
                id="gradient-1"
                v-on:click="changeColor"
              ></div>
              <div
                class="color-box1 gradient-2"
                id="gradient-2"
                v-on:click="changeColor"
              ></div>
              <div
                class="color-box1 gradient-3"
                id="gradient-3"
                v-on:click="changeColor"
              ></div>
              <div
                class="color-box1 gradient-4"
                id="gradient-4"
                v-on:click="changeColor"
              ></div>
              <div
                class="color-box1 gradient-9"
                id="gradient-9"
                v-on:click="changeColor"
              ></div>
              <div
                class="color-box1 gradient-5"
                id="gradient-5"
                v-on:click="changeColor"
              ></div>
              <div
                class="color-box1 gradient-6"
                id="gradient-6"
                v-on:click="changeColor"
              ></div>
              <div
                class="color-box1 gradient-7"
                id="gradient-7"
                v-on:click="changeColor"
              ></div>
              <div
                class="color-box1 gradient-8"
                id="gradient-8"
                v-on:click="changeColor"
              ></div>
            </div>
            <button type="button" @click.prevent="reed" class="post-submit1">
              <span v-if="uploadPercentage1"
                >Posting..
                <span style="color: red">{{ uploadPercentage1 }}%</span></span
              ><span v-else>Submit</span>
            </button>
          </div>
        </div>
        <div class="create-text-story-modal1">
          <div class="story-content1">
            <div class="story-title">
              <h2>
                Upload your <em v-if="isImage">Image</em
                ><em v-if="isImage && isVideo">&nbsp; & &nbsp;</em
                ><em v-if="isVideo">Video</em> Read below
              </h2>
              <span class="cancelBtn1"
                ><i><svg-icon name="multiply"></svg-icon></i
              ></span>
            </div>
            <div class="story-body">
              <div v-if="isImage" class="vac-media-container">
                <div class="vac-media-file">
                  <span v-for="(image, index) in imageFile" :key="index">
                    <div
                      class="vac-svg-button vac-icon-media"
                      @click="removeFile(index)"
                    >
                      <slot name="image-close-icon">
                        <svg-icon name="close" param="image" />
                      </slot>
                    </div>
                    <img :src="image" />
                  </span>
                </div>
              </div>

              <div v-if="isVideo" class="vac-media-container">
                <div class="vac-media-file">
                  <span v-for="(vide, index) in videoFile" :key="index">
                    <div
                      class="vac-svg-button vac-icon-media"
                      @click="removeFile1(index)"
                    >
                      <slot name="image-close-icon">
                        <svg-icon name="close" param="image" />
                      </slot>
                    </div>
                    <video width="100%" height="100%" controls>
                      <source :src="vide" type="video/mp4" />
                      <source :src="vide" type="video/ogg" />
                      <source :src="vide" type="video/webm" />
                    </video>
                  </span>
                </div>
              </div>
            </div>

            <button type="button" @click.prevent="reed1" class="post-submit1">
              <span v-if="uploadPercentage"
                >Uploading
                <span style="color: red">{{ uploadPercentage }}%</span></span
              ><span v-else>Submit</span>
            </button>
          </div>
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import {
  IonContent,
  IonRefresher,
  IonRefresherContent,
  IonPage,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonBackButton,
  IonHeader,
} from "@ionic/vue";
import HeaderSection from "../components/navBar/header.vue";
import SvgIcon from "../SvgIcon";
const { isImageFile, isVideoFile } = require("../../utils/mediaFile");
export default {
  components: {
    IonContent,
    IonRefresher,
    IonRefresherContent,
    IonPage,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    IonBackButton,
    IonHeader,
    HeaderSection,
    SvgIcon,
  },
  data() {
    return {
      color: "gradient-1",
      file: null,
      imageFile: [],
      videoFile: [],
      isImage: null,
      isVideo: null,
      files: [],
      uploadPercentage: 0,
      uploadPercentage1: 0,
      duration: 0,
    };
  },
  methods: {
    removeFile(index) {
      this.imageFile.splice(index, 1);
    },
    removeFile1(index) {
      this.videoFile.splice(index, 1);
    },
    async onFileChange(files) {
      for (var f in files) {
        const file = files[f];
        const fileURL = URL.createObjectURL(file);
        const blobFile = await fetch(fileURL).then((res) => res.blob());
        const typeIndex = file.name.lastIndexOf(".");

        this.file = {
          blob: blobFile,
          name: file.name.substring(0, typeIndex),
          size: file.size,
          type: file.type,
          extension: file.name.substring(typeIndex + 1),
          localUrl: fileURL,
        };

        this.files.push(file);

        this.message_file = file.name;
        // file.name.substring(0, typeIndex);

        if (isImageFile(this.file)) {
          this.imageFile.push(fileURL);
          this.isImage = fileURL;
        } else if (isVideoFile(this.file)) {
          this.videoFile.push(fileURL);
          this.isVideo = fileURL;
        }
      }
    },
    reed() {
      let formData = new FormData();
      formData.append("story_id", this.$store.state.story_id.pk);
      formData.append("tipo", this.$refs.roomTextarea1.value);
      formData.append("font", "font");
      formData.append("background", this.color);
      axios
        .post(`${this.$store.state.endpoints.newReed}`, formData, {
          headers: { Authorization: `Bearer ${this.$store.state.jwt}` },
          onUploadProgress: (progressEvent) => {
            this.uploadPercentage1 = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          },
        })
        .then(() => {
          console.log();
          document.querySelector(".cancelBtn").click();
          this.$store.dispatch("stories");
          this.uploadPercentage1 = 0;
          this.$router.push("/stories/reads");
        });
    },
    reed1() {
      let formData = new FormData();
      formData.append("story_id", this.$store.state.story_id.pk);
      formData.append("tipo", this.$refs.roomTextarea1.value);
      formData.append("font", "font");
      formData.append("background", this.color);
      for (var i = 0; i < this.files.length; i++) {
        let file = this.files[i];
        formData.append("files", file);
      }

      axios
        .post(`${this.$store.state.endpoints.newReed}`, formData, {
          headers: { Authorization: `Bearer ${this.$store.state.jwt}` },
          onUploadProgress: (progressEvent) => {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          },
        })
        .then(() => {
          console.log();
          document.querySelector(".cancelBtn1").click();
          this.$store.dispatch("stories");
          this.uploadPercentage = 0;
          this.$router.push("/stories/reads");
          (this.imageFile = []), (this.videoFile = []);
        });
    },
    onChangeInput() {
      this.resizeTextarea();
    },
    resizeTextarea() {
      const el = this.$refs["roomTextarea1"];

      if (!el) return;

      const padding = window
        .getComputedStyle(el, null)
        .getPropertyValue("padding-top")
        .replace("px", "");

      el.style.height = 0;
      el.style.height = el.scrollHeight - padding * 2 + "px";
    },
    changeColor(e) {
      const heading = document.querySelector("#demo");
      const gradient = e.target.id;
      heading.classList = [];
      heading.classList.add(gradient);
      this.color = gradient;
    },
  },
  mounted() {
    const color_boxes = document.querySelectorAll(".color-box");

    for (let i = 0; i < color_boxes.length; i++) {
      color_boxes[i].onclick = function () {
        const prevActive = document.querySelector(".current-color");
        prevActive != null && prevActive.classList.remove("current-color");

        this.classList.add("current-color");
      };
    }
    //image /video
    const fileTrigger = document.querySelector("#read-file1");
    const fileBtn = document.getElementById("uploadBtn1");
    if (fileBtn) {
      fileBtn.addEventListener("click", () => {
        fileTrigger.click();

        fileTrigger.addEventListener("change", function () {
          const file = this.files[0];
        });
      });
    }

    const text_modal_Interface = document.querySelector(
      ".create-text-story-modal"
    );
    const text_modalBox = document.querySelector(".story-content");
    const text_Box = document.querySelector(".text-box");
    const close_Btn = document.querySelector(".cancelBtn");
    if (text_Box) {
      text_Box.addEventListener("click", () => {
        text_modal_Interface.style.display = "flex";
        text_modalBox.classList.add("zoomIn");
      });
    }
    if (close_Btn) {
      close_Btn.addEventListener("click", () => {
        text_modal_Interface.style.display = "none";
      });
    }

    window.addEventListener("click", (e) => {
      if (e.target == text_modal_Interface) {
        text_modal_Interface.style.display = "none";
      }
    });

    const text_modal_Interface1 = document.querySelector(
      ".create-text-story-modal1"
    );
    const text_modalBox1 = document.querySelector(".story-content1");
    const text_Box1 = document.querySelector(".upload-box");
    const close_Btn1 = document.querySelector(".cancelBtn1");
    if (text_Box1) {
      text_Box1.addEventListener("click", () => {
        text_modal_Interface1.style.display = "flex";
        text_modalBox1.classList.add("zoomIn");
      });
    }
    if (close_Btn1) {
      close_Btn1.addEventListener("click", () => {
        text_modal_Interface1.style.display = "none";
      });
    }

    window.addEventListener("click", (e) => {
      if (e.target == text_modal_Interface1) {
        text_modal_Interface1.style.display = "none";
      }
    });

    //progress implementation

    const postBtn = document.querySelector(".post-submit1");
    const postPage = document.querySelector(".post-progress-body1");
    if (postBtn) {
      postBtn.addEventListener("click", function () {
        postPage.style.display = "block";
      });
    }
    if (postPage) {
      postPage.addEventListener("click", function () {
        postPage.style.display = "none";
      });
    }
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Quicksand:wght@500;700&display=swap");

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
ul {
  list-style: none;
}
a {
  text-decoration: none;
}
body {
  font-family: "Quicksand", sans-serif;
  background: rgb(240, 240, 240);
}

.inner-row {
  width: 85%;
  margin: auto;
}
.profile-image {
  width: 2.7rem;
  aspect-ratio: 1/1;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  overflow: hidden;
  box-shadow: 0px 0px 1px 1px gainsboro;
}
img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

header {
  width: 100%;
  background: white;
  position: fixed;
  z-index: 10;
  height: 70px;
  box-shadow: 0px 1px 2px rgb(231, 231, 231);
}
header .inner-row {
  height: inherit;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.header .logo-section {
  width: 50px;
  height: 50px;
}
.logo-section img {
  width: 135px;
}
.left-nav,
.right-nav {
  display: flex;
  align-items: center;
}

header .search-bar {
  background: whitesmoke;
  margin-left: 5%;
  width: 300px;
  padding: 0.5rem;
  border-radius: 1.2rem;
  -webkit-border-radius: 1.2rem;
  -moz-border-radius: 1.2rem;
  -ms-border-radius: 1.2rem;
  -o-border-radius: 1.2rem;
}
.search-control {
  border: none;
  background: transparent;
  outline: none;
  width: 80%;
  font-family: "Quicksand", sans-serif;
  color: #333;
}
.quick-links {
  margin-right: 5%;
  display: flex;
}
.quick-links .notify,
.quick-links .message {
  font-size: 1.5rem;
  cursor: pointer;
  color: rgb(80, 80, 80);
}
.profile-section {
  display: flex;
  align-items: center;
}
.profile-name {
  display: flex;
  align-items: center;
}
.profile-name h2 {
  font-size: 0.9rem;
  margin-left: 0.5rem;
  color: rgb(80, 80, 80);
}
.profile-name span {
  font-size: 1.2rem;
  cursor: pointer;
}

.navTrigger {
  cursor: pointer;
  width: 30px;
  height: 25px;
  margin: auto;
  position: absolute;
  right: 20px;
  top: 20px;
  display: none;
  z-index: inherit;
}
.navTrigger i {
  background: #222;
  width: 100%;
  content: "";
  display: block;
  height: 4px;
  border-radius: 2px;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  -ms-border-radius: 2px;
  -o-border-radius: 2px;
}
.navTrigger i:nth-child(1) {
  animation: outTp 0.8s backwards;
  -webkit-animation: outTp 0.8s backwards;
  animation-direction: reverse;
}
.navTrigger i:nth-child(2) {
  margin: 5px 0;
  animation: outMd 0.8s backwards;
  -webkit-animation: outMd 0.8s backwards;
  animation-direction: reverse;
}
.navTrigger i:nth-child(3) {
  animation: outBtm 0.8s backwards;
  -webkit-animation: outBtm 0.8s backwards;
  animation-direction: reverse;
}
.navTrigger.active i:nth-child(1) {
  -webkit-animation: inTp 0.8s forwards;
  animation: inTp 0.8s forwards;
}

.navTrigger.active i:nth-child(2) {
  -webkit-animation: inMd 0.8s forwards;
  animation: inMd 0.8s forwards;
}

.navTrigger.active i:nth-child(3) {
  -webkit-animation: inBtm 0.8s forwards;
  animation: inBtm 0.8s forwards;
}
/*Keyframes*/
@keyframes inMd {
  50% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(45deg);
  }
}

@keyframes outMd {
  50% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(45deg);
  }
}

@keyframes inTp {
  0% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(9px) rotate(0deg);
  }
  100% {
    transform: translateY(9px) rotate(135deg);
  }
}

@keyframes outTp {
  0% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(9px) rotate(0deg);
  }
  100% {
    transform: translateY(9px) rotate(135deg);
  }
}

@keyframes inBtm {
  0% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(-9px) rotate(0deg);
  }
  100% {
    transform: translateY(-9px) rotate(135deg);
  }
}

@keyframes outBtm {
  0% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(-9px) rotate(0deg);
  }
  100% {
    transform: translateY(-9px) rotate(135deg);
  }
}

@media (max-width: 930px) {
  .right-container {
    display: none;
  }
  .main-wrapper .inner-row {
    grid-template-columns: 4rem auto;
    gap: 1rem;
  }
}
@media (max-width: 700px) {
  .navTrigger {
    display: block;
  }
  .middle-container {
    width: 100%;
    display: block;
    margin-bottom: 9rem;
  }
  .main-wrapper .inner-row {
    grid-template-columns: repeat(1, 1fr);
    display: block;
  }
  header .search-bar,
  .right-nav,
  .sidebar {
    display: none;
  }
  .mobile-navigation {
    display: flex;
  }
}

.main-content {
  position: relative;
  top: 70px;
}

.main-content .right-content {
  height: 88vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.right-content .content-inner {
  width: 60%;
  display: flex;
  justify-content: space-around;
  gap: 1rem;
}
.right-content .upload-box,
.right-content .text-box {
  text-align: center;
  width: 200px;
  height: 200px;
  box-shadow: 0px 0px 1px 1px rgb(179, 179, 179);
  cursor: pointer;
  border-radius: 0.5rem;
  -webkit-border-radius: 0.5rem;
  -moz-border-radius: 0.5rem;
  -ms-border-radius: 0.5rem;
  -o-border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.right-content span {
  font-size: 1.8rem;
  display: block;
  margin-bottom: 20px;
}
.right-content h3 {
  font-size: 1rem;
  color: #333;
}

.create-text-story-modal {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.884);
  display: flex;
  justify-content: center;
  align-items: center;
  display: none;
  z-index: 999;
  overflow: scroll;
  scrollbar-width: none;
}
.create-text-story-modal1 {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.884);
  display: flex;
  justify-content: center;
  align-items: center;
  display: none;
  z-index: 999;
  overflow: scroll;
  scrollbar-width: none;
}
::-webkit-scrollbar {
  width: 0;
}
.story-content {
  width: 500px;
  max-height: 600px;
  background-color: white;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
  padding: 1rem;
  box-shadow: 0px 0px 3px 1px gainsboro;
  overflow-y: scroll;
  position: relative;
}

.story-content1 {
  width: 500px;
  max-height: 600px;
  background-color: white;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
  padding: 1rem;
  box-shadow: 0px 0px 3px 1px gainsboro;
  overflow-y: scroll;
  position: relative;
}

.story-title {
  text-align: center;
  padding: 0.8rem 0;
  border-bottom: 1px solid gainsboro;
  margin-bottom: 1rem;
  position: relative;
}
.story-title h2 {
  font-size: 1.2rem;
  color: #333;
}
.story-title span {
  position: absolute;
  right: -10px;
  top: -10px;
  font-size: 1.5rem;
  cursor: pointer;
}

.story-body .text-area {
  font-family: "Quicksand";
  font-size: 2rem;
  border: none;
  outline: none;
  padding-left: 0.2rem;
  width: 100%;
  max-height: 300px;
  resize: none;
  text-align: center;
  word-break: break-all;
  display: flex;
  margin: auto;
  overflow: scroll;
}
.color-pallet {
  display: flex;
  margin: 0.5rem 0;
  justify-content: space-between;
}

.color-pallet .color-box1 {
  width: 30px;
  height: 30px;
  border-radius: 5px;
  cursor: pointer;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
}
.color-box1 {
  width: 4rem;
  height: 100%;
  border-radius: 5px;
  margin-right: 0.5rem;
  border: none;
  border: 4px solid #f4ecea;
  cursor: pointer;
  transition: 0.3s ease;

  &:hover {
    border: 4px solid darken(#f5efed, 20%);
  }

  &:focus {
    outline: none;
  }
}

.color-box1.current-color {
  box-shadow: 0px 0px 3px 3px rgb(201, 201, 201);
}
/* .color-box.red{
          background: linear-gradient(pink, orange);
    }
    .color-box.green{
          background-color: green;
    }
    .color-box.violet{
          background-color: violet;
    }
    .color-box.orange{
          background-color: orange;
    }
    .color-box.blue{
          background:blue;
    }
    .color-box.black{
          background:black;
    }
    .color-box.indigo{
          background:indigo;
    }
    .color-box.yellow{
          background:yellow;
    }
    .color-box.white{
          border:1px solid gainsboro;
    }
    
    
    .color-box1.red{
          background-color: red;
    }
    .color-box1.green{
          background-color: green;
    }
    .color-box1.violet{
          background-color: violet;
    }
    .color-box1.orange{
          background-color: orange;
    }
    .color-box1.blue{
          background:blue;
    }
    .color-box1.black{
          background:black;
    }
    .color-box1.indigo{
          background:indigo;
    }
    .color-box1.yellow{
          background:yellow;
    }
    .color-box1.white{
          border:1px solid gainsboro;
    } */

.color-box.gradient-1 {
  background: linear-gradient(pink, orange);
}

.color-box.gradient-2 {
  background: linear-gradient(19deg, #21d4fd 0%, #b721ff 100%);
}

.color-box.gradient-3 {
  background: linear-gradient(45deg, #fa8bff 0%, #2bd2ff 52%, #2bff88 90%);
}

.color-box.gradient-4 {
  background-image: linear-gradient(
    90deg,
    #ff9a8b 0%,
    #ff6a88 55%,
    #ff99ac 100%
  );
}

.color-box.gradient-5 {
  background-image: linear-gradient(0deg, #ffdee9 0%, #b5fffc 100%);
}

.color-box.gradient-6 {
  background-image: linear-gradient(19deg, #3eecac 0%, #ee74e1 100%);
}

.color-box.gradient-7 {
  background-image: linear-gradient(
    225deg,
    #ff3cac 0%,
    #784ba0 50%,
    #2b86c5 100%
  );
}

.color-box.gradient-8 {
  background-image: linear-gradient(0deg, #08aeea 0%, #2af598 100%);
}

.color-box.gradient-9 {
  border: 1px solid gainsboro;
}

.color-box1.gradient-1 {
  background: linear-gradient(pink, orange);
}

.color-box1.gradient-2 {
  background: linear-gradient(19deg, #21d4fd 0%, #b721ff 100%);
}

.color-box1.gradient-3 {
  background: linear-gradient(45deg, #fa8bff 0%, #2bd2ff 52%, #2bff88 90%);
}

.color-box1.gradient-4 {
  background-image: linear-gradient(
    90deg,
    #ff9a8b 0%,
    #ff6a88 55%,
    #ff99ac 100%
  );
}

.color-box1.gradient-5 {
  background-image: linear-gradient(0deg, #ffdee9 0%, #b5fffc 100%);
}

.color-box1.gradient-6 {
  background-image: linear-gradient(19deg, #3eecac 0%, #ee74e1 100%);
}

.color-box1.gradient-7 {
  background-image: linear-gradient(
    225deg,
    #ff3cac 0%,
    #784ba0 50%,
    #2b86c5 100%
  );
}

.color-box1.gradient-8 {
  background-image: linear-gradient(0deg, #08aeea 0%, #2af598 100%);
}

.color-box1.gradient-9 {
  border: 1px solid gainsboro;
}
.story-content p {
  font-size: 14px;
}

.story-content button {
  display: block;
  background: blue;
  width: 100%;
  margin-top: 1.2rem;
  height: 45px;
  border: none;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
  font-size: 14px;
  font-family: "Quicksand";
  color: white;
  cursor: pointer;
}

.story-content1 button {
  display: block;
  background: blue;
  width: 100%;
  margin-top: 1.2rem;
  height: 45px;
  border: none;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
  font-size: 14px;
  font-family: "Quicksand";
  color: white;
  cursor: pointer;
}
@media (max-width: 930px) {
  .right-content .content-inner {
    width: 80%;
    display: block;
  }
  .right-content .upload-box,
  .right-content .text-box {
    width: 100%;
    margin-bottom: 1rem;
  }
}
@media (max-width: 600px) {
  .story-content {
    width: 90%;
  }
}

.add-story {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #dddddd;
  cursor: pointer;
}
.add-story span {
  font-size: 1.3rem;
  color: blue;
}
.story-description p {
  font-size: 12px;
}

.left-content .title {
  margin: 1rem 0;
}

.friend-story {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
}
.friend-story .profile-image {
  border: 2px solid blue;
}
.story-meta p {
  font-size: 12px;
  color: gray;
}
.mobile-navigation {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  background: #fff;
  z-index: 99;
  display: none;
  justify-content: space-around;
  padding: 0.5rem 0;
  border-top: 1px solid gainsboro;
}
.mobile-nav-item a {
  color: #333;
}
.mobile-nav-item i {
  font-size: 1.3rem;
}

.mobile-sidebar {
  height: 100%;
  position: fixed;
  right: 0;
  bottom: 0;
  z-index: 9;
  background: white;
  width: 50%;
  padding: 4rem 0.5rem;
  box-shadow: 0px 1px 1px 1px rgb(163, 163, 163);
  margin-right: -100%;
  transition: all 1s ease;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -ms-transition: all 1s ease;
  -o-transition: all 1s ease;
}
.mobile-sidebar.active {
  height: 100%;
  position: fixed;
  right: 0;
  bottom: 0;
  z-index: 9;
  background: white;
  width: 50%;
  padding: 4rem 0.5rem;
  box-shadow: 0px 1px 1px 1px rgb(163, 163, 163);
  margin-right: 0;
}
.mobile-nav-link {
  display: block;
  line-height: 40px;
  color: #222;
  font-size: 0.9rem;
}

.mobile-profile {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  margin: 1rem 0;
}
.mobile-profile .profile-text p {
  font-size: 0.7rem;
  color: #444;
}
.mobile-sidebar .logout {
  padding: 0.5rem 0;
  margin-top: 1rem;
  border-top: 1px solid gainsboro;
}
.mobile-sidebar .logout a {
  font-size: 0.9rem;
  color: #222;
}
.vac-media-container {
  z-index: -1;
}
.vac-icon-media {
  display: flex;
  justify-content: flex-end;
  position: absolute;

  // justify-content:flex-end;
  z-index: 10;

  svg {
    height: 30px;
    width: 30px;
    border-radius: 50%;
  }

  &:before {
    content: " ";
    position: absolute;
    width: 100%;
    height: 100%;
    // background: rgba(0, 0, 0, 0.5);
    border-radius: 50%;
  }
}
.vac-media-file {
  width: 100%;
  height: 100%;
  max-height: 300px;
  overflow: scroll;
  margin: 1rem 0;
  border-radius: 1rem;
  -webkit-border-radius: 1rem;
  -moz-border-radius: 1rem;
  -ms-border-radius: 1rem;
  -o-border-radius: 1rem;
  display: grid;
  grid-template-columns: auto auto auto auto;

  img {
    border-radius: 15px;
    width: 100%;
    max-width: 100%;
    height: 100%;
    object-fit: cover;
  }

  video {
    border-radius: 15px;
    width: 100%;
    max-width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
em {
  font-style: normal;
}
.post-progress-body1 {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  background: white;
  display: none;
}

.post-progress-body1 span {
  position: fixed;

  justify-content: center;
  align-items: center;
  top: 50%;
  left: 45%;
  right: 45%;
}
.post-progress-body1 {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  background: white;
  display: none;
}

.post-progress-body1 span {
  position: fixed;

  justify-content: center;
  align-items: center;
  top: 50%;
  left: 45%;
  right: 45%;
}
</style>
